import MisioneroIngresoPagina from "./MisioneroIngresoPagina";

export default MisioneroIngresoPagina;